import { getLink } from "@trydig/storyblok";
import { routing } from "@/i18n/routing";

export type LinkInsert = Parameters<typeof getLink>[0] | string;

export const sbLink = (link: Parameters<typeof getLink>[0] | string) => {
	const result = getLink(link as Parameters<typeof getLink>[0], [
		...routing.groups,
		...routing.languages,
	]);

	return result;
};
